import React from 'react';
import LocationTemplate from './LocationTemplate';

const ElizabethCityPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Elizabeth City"
      stateName="North Carolina"
      countyName="Pasquotank"
      zipCodes={["27909", "27906"]}
      latitude={36.2946}
      longitude={-76.2511}
      population={17188}
      historicalFact="Founded in 1793, known as the 'Harbor of Hospitality' and home to the Coast Guard Air Station."
      nearbyTowns={[
        "Hertford, NC",
        "Edenton, NC",
        "Camden, NC",
        "Great Bridge, VA",
        "Chesapeake, VA",
        "Winfall, NC",
        "Columbia, NC",
        "Manteo, NC"
      ]}
    />
  );
};

export default ElizabethCityPage;